import uuid from 'draft-js/lib/uuid';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';

const verifyAudioUpload = (audioId, apiVersion, callback, errorCallback) => {
  return async (dispatch) => {
    let unsubscribe = onAuthStateChanged(auth, async (user) => {
      const token = await user.getIdToken();
      try {
        const response = await axios.put(
          `/cs/conversation/message/${audioId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'x-api-version': apiVersion || 'v1',
            },
            params: {
              'request-id': uuid(),
            },
          },
        );
        console.log(response);
        if (typeof callback === 'function') callback();
        if (response.status === 200) {
          console.log('im here');
        } else {
          if (typeof errorCallback === 'function') errorCallback();
        }
      } catch (e) {
        console.log(e);
      }
      unsubscribe();
    });
  };
};

export default verifyAudioUpload;
